import { render, staticRenderFns } from "./relate_form.vue?vue&type=template&id=b4ed7478&scoped=true&"
import script from "./relate_form.vue?vue&type=script&lang=js&"
export * from "./relate_form.vue?vue&type=script&lang=js&"
import style0 from "./relate_form.vue?vue&type=style&index=0&id=b4ed7478&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ed7478",
  null
  
)

export default component.exports